export default __webpack_public_path__ + "603e8ba86b69cdefc8a3c389ad0f7e46.png";